import generateCRUD from "components/adminServices/generateCRUD";

const PagesCRUD = generateCRUD("pages");

export default class AdminPagesService extends PagesCRUD {
  static update = ({ id, name, lang, originalPageId }) => {
    return PagesCRUD.update({ id, name, lang, originalPageId });
  };
}
